import { render, staticRenderFns } from "./refuse.vue?vue&type=template&id=34844e1a&scoped=true"
import script from "./refuse.vue?vue&type=script&lang=js"
export * from "./refuse.vue?vue&type=script&lang=js"
import style0 from "./refuse.vue?vue&type=style&index=0&id=34844e1a&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34844e1a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data01/test/dev.console.insureforce.cn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('34844e1a')) {
      api.createRecord('34844e1a', component.options)
    } else {
      api.reload('34844e1a', component.options)
    }
    module.hot.accept("./refuse.vue?vue&type=template&id=34844e1a&scoped=true", function () {
      api.rerender('34844e1a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/claim/customerRecordManage/recordFrom/refuse.vue"
export default component.exports